<div class="modal-header">
  <h4 class="modal-title">Update Password</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="form-group">
      <label for="currentPassword">Current Password</label>
      <input ngbAutofocus type="password" class="form-control" formControlName="currentPassword" id="currentPassword" placeholder="Current Password" [ngClass]="{ 'is-invalid': formControls.currentPassword.touched && formControls.currentPassword.errors }" autocomplete="current-password">
      <div *ngIf="formControls.currentPassword.touched  && formControls.currentPassword.errors" class="invalid-feedback">
        <div *ngIf="formControls.currentPassword.errors.required">Current password is required</div>
        <div *ngIf="formControls.currentPassword.errors.invalidPassword">Incorrect password</div>
      </div>
    </div>
    <div class="form-group">
      <label for="newPassword">New Password</label>
      <input type="password" class="form-control" formControlName="newPassword" id="newPassword" placeholder="New Password" [ngClass]="{ 'is-invalid': formControls.newPassword.touched && formControls.newPassword.errors }" autocomplete="new-password">
      <div *ngIf="formControls.newPassword.touched  && formControls.newPassword.errors" class="invalid-feedback">
        <div *ngIf="formControls.newPassword.errors.required">New password is required</div>
        <div *ngIf="formControls.newPassword.errors.minlength">Your password must be longer than {{ formControls.newPassword.errors.minlength.requiredLength }} characters</div>
      </div>
    </div>
    <div class="form-group">
      <label for="confirmNewPassword">Confirm New Password</label>
      <input type="password" class="form-control" formControlName="confirmNewPassword" id="confirmNewPassword" placeholder="Confirm New Password" [ngClass]="{ 'is-invalid': formControls.confirmNewPassword.touched && formControls.confirmNewPassword.errors }" autocomplete="new-password">
      <div *ngIf="formControls.confirmNewPassword.touched  && formControls.confirmNewPassword.errors" class="invalid-feedback">
        <div *ngIf="formControls.confirmNewPassword.errors.required">Confirming the new password is required</div>
        <div *ngIf="formControls.confirmNewPassword.errors.confirmation">Passwords do not match</div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer d-flex justify-content-between">
  <button type="button" class="btn btn-link btn-sm" (click)="modal.close()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="submit()" [attr.disabled]="loading ? loading : null" [class.loading]="loading">Change Password</button>
</div>
